import { Loaders } from 'shared';
import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    fontSize: '18px',
    textAlign: 'center',
    padding: '8px 0',
    cursor: 'default',
    marginRight: '10px',
  },
}));

const LoadingIndicator = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Loaders.ContentLoader thickness={2} size={18} height={16} />
    </div>
  );
};

export default LoadingIndicator;
